import React from 'react';
import {
  Card,
  CardContent,
  Typography,
} from '@mui/material';
import MainLayout from '../components/MainLayout';
import { PageHeader } from '../components/ui/PageHeader';

const Transcripts: React.FC = () => {
  return (
    <MainLayout title="Transcripts">
      <div className="p-2">
        <PageHeader title="Call Transcripts" description="View and manage AI sales assistant conversation transcripts" />

      <Card elevation={1}>
        <CardContent className="p-6">
          <Typography variant="h6" gutterBottom>
            Recent Transcripts
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Transcript management functionality will be implemented here.
          </Typography>
        </CardContent>
      </Card>
      </div>
    </MainLayout>
  );
};

export default Transcripts;